import React from 'react';

const Meet = () => {
  return <div className="meet-metafans"></div>;
};

export default Meet;
